import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { BooksPage } from "~/pages/books/books-page";

export const Route = createFileRoute("/_app/books/")({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.books") }] }),
  component: BooksPage,
});
